import { ATTACHMENTS_PLACEMENTS } from '@savgroup-front-common/constants';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import { AdditionalClaimInformation } from '@savgroup-front-common/types';

interface AdaptAdditionalInformationToDocumentDataArgs {
  additionalInformation?: AdditionalClaimInformation[];
  fileId: string;
}

export const adaptAdditionalInformationToDocumentData = ({
  additionalInformation,
  fileId,
}: AdaptAdditionalInformationToDocumentDataArgs): DocumentData[] => {
  return (additionalInformation || [])
    .filter(
      (information) =>
        information.additionalInformationFileValue &&
        information.additionalInformationFileValue.customerVisibility,
    )
    .map((information) => {
      const { additionalInformationFileValue, additionalInformationLabel } =
        information;
      const documentName = additionalInformationLabel
        ? `${additionalInformationLabel} : ${additionalInformationFileValue?.fileName}`
        : additionalInformationFileValue?.fileName || '';

      return {
        ...additionalInformationFileValue,
        label: additionalInformationLabel,
        fileId,
        attachmentId: additionalInformationFileValue?.url,
        documentName,
        type: ATTACHMENTS_PLACEMENTS.ADDITIONAL_INFORMATION_DOCUMENTS,
      };
    });
};
